<template>
  <a-card :bordered="false">
    <a-form-item><a @click="routeBack">&lt;&lt; 返回</a></a-form-item>
    <detail-list title="化验记录详情" v-if="mdl">
      <detail-list-item term="物流单号">{{ mdl.logisticsNo }}</detail-list-item>
      <detail-list-item term="卡号">{{ mdl.cardNo }}</detail-list-item>
      <detail-list-item term="车牌号">{{ mdl.carlicence }}</detail-list-item>
      <detail-list-item term="Al2O3">{{ mdl.al2o3 }}</detail-list-item>
      <detail-list-item term="收到基灰分">{{ mdl.ash }}</detail-list-item>

      <detail-list-item term="干基灰分">{{ mdl.dAsh }}</detail-list-item>
      <detail-list-item term="干基发热量">{{ mdl.dHeat }}</detail-list-item>
      <detail-list-item term="干基硫">{{ mdl.dS }}</detail-list-item>
      <detail-list-item term="干基挥发分">{{ mdl.dVC }}</detail-list-item>
      <detail-list-item term="CaO">{{ mdl.cao }}</detail-list-item>
      <detail-list-item term="Fe2O3化验结果">{{ mdl.fe2o3 }}</detail-list-item>
      <detail-list-item term="收到基低位热值">{{ mdl.heat }}</detail-list-item>
      <detail-list-item term="MgO检验结果">{{ mdl.mgO }}</detail-list-item>
      <detail-list-item term="SiO2检验结果">{{ mdl.siO2 }}</detail-list-item>
      <detail-list-item term="收到基硫">{{ mdl.spercent }}</detail-list-item>
      <detail-list-item term="收到基挥发分">{{ mdl.vC }}</detail-list-item>
      <detail-list-item term="全水分">{{ mdl.wet }}</detail-list-item>
      <detail-list-item term="日期">{{ mdl.date }}</detail-list-item>
      <detail-list-item term="采样开始日期">{{ mdl.decTimeBegin }}</detail-list-item>
      <detail-list-item term="采样结束日期">{{ mdl.decTimeEnd }}</detail-list-item>
      <detail-list-item term="罐号">{{ mdl.num }}</detail-list-item>
      <detail-list-item term="供应商">{{ mdl.provider }}</detail-list-item>
      <detail-list-item term="是否合格">{{ mdl.result }}</detail-list-item>

    </detail-list>
  </a-card>
  </page-view>
</template>

<script>
  import DetailList from '@/components/tools/DetailList'
  import Moment from 'moment'
  import { common } from '@/api/sys'
  import storage from "@/utils/storage"

  const DetailListItem = DetailList.Item

  export default {
    name: 'assayDetail',
    components: {
      DetailList,
      DetailListItem,
    },
    data () {
      return {
        mdl: null,
      }
    },
    mounted () {
      this.initData()
    },
    filters: {
      formatDate (value) {
        return Moment(value).format('YYYY-MM-DD HH:mm:ss')
      }
    },
    methods: {
      routeBack(){
        localStorage.setItem('goback', "true");
        this.$router.back(-1)
      },
      initData () {
        let cache = storage.fetch("cache-AssayDetail");
        if (cache){
            this.mdl = JSON.parse(cache);
        } 
       },

    }
  }
</script>



